$(function(){
    $('.catalog-section__filter-btn').click(function() {
        $('.catalog-section__filter').toggleClass('catalog-section__filter--show');
        $('body').toggleClass('overflow-hidden');
    });
});

$(function(){
    $('.catalog-section__filter-close').click(function() {
        $('.catalog-section__filter').removeClass('catalog-section__filter--show');
        $('body').removeClass('overflow-hidden');
    });
});